import { render } from "./EditWordsAndExpressions.vue?vue&type=template&id=4c4dda60&scoped=true"
import script from "./EditWordsAndExpressions.vue?vue&type=script&lang=js"
export * from "./EditWordsAndExpressions.vue?vue&type=script&lang=js"

import "./EditWordsAndExpressions.vue?vue&type=style&index=0&id=4c4dda60&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c4dda60"]])

export default __exports__